import React from 'react';

import { aiConfigItemMessages, aiMessages } from '@atlaskit/editor-common/ai-messages';
import {
	AI_ASK_ROVO_MENU_ITEM,
	AI_IMPROVE_WRITING_MENU_ITEM,
	AI_POLISH_MENU_ITEM,
} from '@atlaskit/editor-common/block-menu';
import { AICommandIcon } from '@atlaskit/editor-toolbar';
import AiGenerativeCleanupIcon from '@atlaskit/icon-lab/core/ai-generative-cleanup';
import { RovoIcon } from '@atlaskit/logo';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import type { EditorPluginAIProvider } from '../../types/types';
import { improveWriting } from '../prebuilt/config-items/prompts/enhance/enhance';
import { addPolish } from '../prebuilt/config-items/prompts/polish/polish';

import type { BlockMenuActionDef } from './types';

/**
 * Default character threshold for determining whether a block is "large".
 * Blocks with text content length >= this value are considered large.
 */
const SMALL_WORD_COUNT_THRESHOLD = 5;
const LARGE_TEXT_THRESHOLD = 300;

export const getBlockMenuActions = ({
	editorPluginAIProvider,
}: {
	editorPluginAIProvider: EditorPluginAIProvider;
}): BlockMenuActionDef[] => {
	return [
		{
			key: AI_ASK_ROVO_MENU_ITEM.key,
			label: aiMessages.askRovoToolbarIconTitle,
			elemBefore: <RovoIcon label="" size="xxsmall" />,
			configItem: editorPluginAIProvider.baseGenerate,
			shouldShowInPrimary: () =>
				true && expValEquals('platform_editor_ai_blockmenu_integration', 'isEnabled', true),
		},
		{
			key: AI_IMPROVE_WRITING_MENU_ITEM.key,
			label: aiConfigItemMessages.improveWritingTitle,
			elemBefore: <AICommandIcon label="" size="small" />,
			configItem: improveWriting(),
			shouldShowInPrimary: ({ textLength, wordCount }) =>
				wordCount >= SMALL_WORD_COUNT_THRESHOLD &&
				textLength < LARGE_TEXT_THRESHOLD &&
				expValEquals('platform_editor_ai_blockmenu_integration', 'isEnabled', true),
		},
		{
			key: AI_POLISH_MENU_ITEM.key,
			label: expValEquals('platform_editor_ai_rename_add_polish', 'isEnabled', true)
				? aiConfigItemMessages.improveFormattingTitle
				: aiConfigItemMessages.addPolishTitle,
			elemBefore: <AiGenerativeCleanupIcon label="" size="small" />,
			configItem: addPolish(),
			shouldShowInPrimary: ({ textLength }) =>
				textLength >= LARGE_TEXT_THRESHOLD &&
				expValEquals('platform_editor_ai_blockmenu_integration', 'isEnabled', true),
		},
	];
};
